import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import {MSG_REQUIRED, MSG_NOT_FOUND, MSG_USER_DOC_ADD_SUCCESS, MSG_USER_DOC_UPDATE_SUCCESS, MSG_USER_DOC_DELETE_SUCCESS, MSG_DOCUMENT_DELETE_424_ERROR, MSG_DOCUMENT_DELETE_ERROR } from '../../configs/msgConfigs';
import {LBL_ADD_NEW,LBL_CLIENT,LBL_DOCUMENT,LBL_DOCUMENTS,LBL_APP_NAME,LBL_SETTINGS,LBL_ACTIONS,LBL_SLNUM,LBL_CLIENT_DOCUMENTS,LBL_DOCUMENT_NAME,LBL_MANDATORY,LBL_DATE_RANGE,LBL_CONFIRM_DELETE,LBL_SELECT, LBL_BACK_TO_SETTINGS } from '../../configs/labelConfigs';   
import {ROUTE_REFRESH,ROUTE_AFFILIATE_REFRESH,LOGIN_CLIENT_GROUP,LOGIN_AFFILIATE_GROUP,LOGIN_SUPER_ADMIN_GROUP,ROUTE_AFFILIATE_SETTINGS,ROUTE_SA_SETTINGS} from '../../configs/staticConfigs';
import * as types from '../../actions';

import ModalWindow from '../commons/helpers/modalWindow';
import Toast from '../commons/helpers/toast';

import {formValid} from '../../utils/validation';
import {getSortClass} from '../../utils/commonUtilities'; 

import {userDocMasterListAction, userDocListAction, userDocAddAction, userDocEditAction, userDocUpdateAction, userDocDeleteAction} from '../../actions/settings/userDocActions';
import {clearAction} from '../../actions/commonActions';

class ClientDocsComponent extends Component { 

    constructor(props){
        super()

        this.state = {            
            activeRowId:0,            
            formErrors:{
                documentName: MSG_REQUIRED,
            },          
            userDocData:{
                docId:'',
                documentName:null,
                isMandatory:false,
                showDateRange:false,
            },
            sortField:'name',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            masterDocItems:[],
            addNewDocIds:[], 
            userGroup: '',
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);

        this.modalDelete = React.createRef();
        this.modal       = React.createRef();
        
    }    

    openModal() { 
        if(this.state.userGroup===LOGIN_AFFILIATE_GROUP) {
            this.props.userDocMasterListAction({column:this.state.sortOrder+this.state.sortField,userType:LOGIN_CLIENT_GROUP}); 
        }
        let formErrors = this.state.formErrors;
        formErrors.documentName = MSG_REQUIRED;
        this.setState({formErrors, addNewDocIds:[],masterDocItems:[]});
        this.modal.current.handleOpenModal();
    }    

    onModalFormReset = () =>{       
        this.setState({userDocData:{
            docId:'',
            documentName:null,
            isMandatory:false,
            showDateRange:false,
        }}); 
    }

    onHandleChange = (event) =>{

        const {name} = event.target;
        let trimmedValue = '';

        const value =
        event.target.type === "checkbox" ? event.target.checked : event.target.value;  
        if(event.target.type==="text"){
            trimmedValue = value.trim(); 
        }  
        let formErrors     = this.state.formErrors;

        switch(name){
            case 'documentName':
                formErrors.documentName = trimmedValue.length <=0 ? MSG_REQUIRED : "";
                break;            
            default :
            break;
        }

        let userDocData   = this.state.userDocData;
        userDocData[name] = value;
      
        this.setState({formErrors,userDocData});

    }    

    onShowActionButtons = (event, rowId) =>{

        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');      

            if(this.state.activeRowId===0){   
                this.setState({activeRowId:rowId}); 
                document.getElementById('img-action-'+rowId).focus(); 
            }
            else if(this.state.activeRowId===rowId){ 
                this.setState({activeRowId:0}); 
            }
            else if(this.state.activeRowId!==rowId){   
                dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
                dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
                dropdown.classList.toggle('show');
                dropdownMenu.classList.toggle('show');
                this.setState({activeRowId:rowId}); 
                document.getElementById('img-action-'+rowId).focus(); 
            }        
        
    }    

    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSaveFormData = (id) =>{
        let affiliate = '';
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup    = ''; 
        let grpProfileId = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            grpProfileId = userGroupData.profile_id;
        }
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            affiliate = grpProfileId;
            if(this.state.addNewDocIds.length===0) {
                return false;
            }
            else {
                let addData = {
                    affiliate: affiliate,
                    document_master:this.state.addNewDocIds,
                    user_type:LOGIN_CLIENT_GROUP,
                }
                this.props.userDocAddAction(addData);    
            }
        }
        else {
            if(formValid(this.state)){  
                let formErrors = this.state.formErrors;   
                let userDocData= {
                    name: this.state.userDocData.documentName,
                    is_mandatory: this.state.userDocData.isMandatory,
                    date_range:this.state.userDocData.showDateRange,
                    user_type:LOGIN_CLIENT_GROUP,
                    affiliate        
                }
                if(id){            
                    userDocData['id']= id;
                    this.props.userDocUpdateAction(userDocData);       
                }else{            
                    this.props.userDocAddAction(userDocData);
                }  
                this.setState({formErrors});               
            }else{
                let formErrors = this.state.formErrors;
                if(this.state.userDocData.documentName==null){
                    formErrors.documentName = MSG_REQUIRED;
                }            

                this.setState({formErrors});
            }
        }
    }    
    
    editBtnClick = (rowId) =>{        
        let formErrors = this.state.formErrors;
        formErrors.documentName = '';
        this.setState(formErrors);
        this.modal.current.handleOpenModal();
        this.props.userDocEditAction(rowId);
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({
            userDocData: {
                docId: rowId,
                documentName:name               
            }
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        let docId = this.state.userDocData.docId;
        this.props.userDocDeleteAction(docId);
        this.modalDelete.current.handleModelClose();                    
    }    

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.userDocListAction({column:sOrder+this.state.sortField,userType:LOGIN_CLIENT_GROUP});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.userDocListAction({column:this.state.sortOrder+sortKey,userType:LOGIN_CLIENT_GROUP});
        }        
    } 

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }   

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    onSelectAddnewCheckbox = (event,docId) => { 
        let arrTemp = this.state.addNewDocIds; 
        if(event.target.checked) {
            if(!arrTemp.includes(docId)) {
                arrTemp.push(docId); 
            }
            this.setState({ addNewdocIds: arrTemp });
        }
        else {
            const index = arrTemp.indexOf(docId);
            if (index > -1) { 
                arrTemp.splice(index, 1); 
            }
            this.setState({ addNewDocIds: arrTemp });
        }            
    }
  
    setStateUpdate(userDoc,status,activity,errorData){
        if(activity===types.USER_DOC_ADD_SUCCESS){
            this.modal.current.handleModelClose();
            this.props.userDocListAction({column:this.state.sortOrder+this.state.sortField,userType:LOGIN_CLIENT_GROUP});
            this.setToasterState(true,MSG_USER_DOC_ADD_SUCCESS,true); 
        }else if(activity===types.USER_DOC_ADD_ERROR){ 
            if(status===400){
                let formErrors = this.state.formErrors;
                if(errorData.hasOwnProperty('name')){
                    formErrors.documentName = errorData.name[0];
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }  
            }  
        }else if(activity===types.USER_DOC_UPDATE_SUCCESS){  
            this.modal.current.handleModelClose(); 
            this.setToasterState(true,MSG_USER_DOC_UPDATE_SUCCESS,true); 
        }else if(activity===types.USER_DOC_UPDATE_ERROR){ 
            if(status===400){
                let formErrors = this.state.formErrors;
                if(errorData.hasOwnProperty('name')){
                    formErrors.documentName = errorData.name[0];
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }  
            }  
        }else if(activity===types.USER_DOC_EDIT_SUCCESS){   
            this.setState({userDocData:{
                docId:userDoc.id,
                documentName:userDoc.name,
                isMandatory:userDoc.isMandatory,
                showDateRange:userDoc.showDateRange
            }}, () => {
                if(document.getElementById('documentName')) {
                    document.getElementById('documentName').focus(); 
                }
            });  
        }else if(activity===types.USER_DOC_DELETE_SUCCESS){
         
            this.props.userDocListAction({column:this.state.sortOrder+this.state.sortField,userType:LOGIN_CLIENT_GROUP});
            
            this.setToasterState(true,MSG_USER_DOC_DELETE_SUCCESS,true);
        }else if(activity===types.USER_DOC_DELETE_ERROR){
            if(status===424){
                this.setToasterState(true,MSG_DOCUMENT_DELETE_424_ERROR,false);
            }
            else {
                this.setToasterState(true,MSG_DOCUMENT_DELETE_ERROR,false);
            }
        }
    }   
    
    componentDidUpdate(prevProps) {    
        const { userDocs,userDoc,status,activity,errorData,masterDocs,masterDocStatus,masterDocActivity} = this.props; 
        if (masterDocActivity && (masterDocStatus !== prevProps.masterDocStatus || masterDocActivity !== prevProps.masterDocActivity)) {
            if (masterDocActivity === types.USER_DOC_MASTER_LIST_SUCCESS && masterDocs && masterDocs.length > 0) {
                let arrAddDocs = [];
                masterDocs.forEach(sdItem => {
                    if (!userDocs.find(item => item.document_master === sdItem.id)) {
                        arrAddDocs.push(sdItem);
                    }
                });
                this.setState({ masterDocItems: arrAddDocs });
                this.props.clearAction();
            }
        }
        
        if (activity !== prevProps.activity) {
            this.setStateUpdate(userDoc,status,activity,errorData);
            this.props.clearAction();
        }       
    }     
  
    componentDidMount() {
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        this.props.userDocListAction({column:this.state.sortOrder+this.state.sortField,userType:LOGIN_CLIENT_GROUP}); 
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_CLIENT_DOCUMENTS;
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
        this.setState({userGroup:userGroup}); 
    }
    
    render(){

        const {
            toastMessage,toastFlag,toastSuccess,userDocData,sortField,sortOrder,masterDocItems,userGroup        
        } = this.state    
        
        const { userDocs,status} = this.props;       

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;

            }
        }

        return(
            <div className="col-md-8">
                 <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={userGroup===LOGIN_AFFILIATE_GROUP ? ROUTE_AFFILIATE_SETTINGS : ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">
                            <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)}>{LBL_ADD_NEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table docs" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                        <th>{LBL_SLNUM}</th>
                                        <th onClick={(e) => this.onSort(e,'name')} className="user-doc spanPointer">{LBL_DOCUMENT_NAME} <i className={sortField=='name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                        <th className="text-center">{LBL_MANDATORY}</th>
                                        <th className="text-center">{LBL_DATE_RANGE}</th>
                                        <th>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(this.props.count===0) &&
                                    <tr>
                                        <td colSpan="5" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                { userDocs.map((item,index) => {
                                    let mandatory = (item.is_mandatory === true) ? 'Y' : 'N';
                                    let showDate = (item.date_range === true) ? 'Y' : 'N';

                                    return (
                                        <tr key={item.id}>
                                            <td>{index+1}</td>
                                            <td>{item.name}</td>
                                            <td className="text-center">{mandatory}</td>
                                            <td className="text-center">{showDate}</td>
                                            <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                    {this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP && <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>Edit</Link>}
                                                    <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.name)}>Delete</Link>
                                                </div>
                                            </div>
                                            </td>
                                        </tr>             
                                     )
                                  })      
                                }                     
                                </tbody>
                            </table>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                {"Are you sure you want to delete document '"+userDocData.documentName+"'?"}
                </ModalWindow>

                <ModalWindow ref={this.modal} header={Number(this.state.userDocData.docId) > 0 ? "Edit "+LBL_CLIENT+" "+LBL_DOCUMENT : "Add "+LBL_CLIENT+" "+LBL_DOCUMENT} saveFormData={ (e)=>this.onSaveFormData(userDocData.docId)} resetModalForm={this.onModalFormReset} autoFocusField='documentName' >
                    
                    {this.state.userGroup===LOGIN_AFFILIATE_GROUP && <div className='row'><table id="data-table" className="table" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th className='text-center widthPer10'>{LBL_SELECT}</th>
                                    <th>{LBL_DOCUMENT_NAME}</th>
                                    <th className="text-center">{LBL_MANDATORY}</th>
                                    <th className="text-center">{LBL_DATE_RANGE}</th>
                                    <th >&nbsp;</th>
                                </tr>
                            </thead>

                            <tbody>
                                {!masterDocItems || !Array.isArray(masterDocItems) || masterDocItems.length === 0 &&
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                {masterDocItems.map((item, index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td className='text-center'>
                                                <div className="form-group">
                                                    <div className="checkbox-wrapper">
                                                        <div className="custom-checkbox">
                                                            <input name={"chk_doc"+index} type="checkbox" id={"chk_doc"+index} checked={this.state.addNewDocIds.includes(item.id) ? true : false} onChange={(e) => this.onSelectAddnewCheckbox(e,item.id)} />
                                                            <label className="checkbox" htmlFor={"chk_doc"+index}></label>
                                                            <label className="labeltext" htmlFor={"chk_doc"+index}>{''}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            <td className="text-center">{(item.is_mandatory === true) ? 'Y' : 'N'}</td>
                                            <td className="text-center">{(item.date_range === true) ? 'Y' : 'N'}</td>
                                            <td >&nbsp;</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>

                    </div>}
                    {this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP && <><div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>{LBL_DOCUMENT} name</label>
                                <div className="text-input"><input className={this.state.formErrors.documentName.length >0 ? "input-error" : ''} name="documentName" id="documentName" type="text" placeholder="" value={userDocData.documentName || ''} onChange={this.onHandleChange} maxLength={120} autoFocus={true} /></div>
                                {this.state.formErrors.documentName.length > 0 && this.state.formErrors.documentName != MSG_REQUIRED && (
                                <div className="text-red left-align text-12">{this.state.formErrors.documentName}</div>
                                )} 
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="checkbox-wrapper">
                                <div className="custom-checkbox"><input name="isMandatory" type="checkbox" id="check2" checked={userDocData.isMandatory} onChange={this.onHandleChange} /><label className="checkbox"htmlFor="check2"></label><label className="labeltext"htmlFor="check2">Mandatory {LBL_DOCUMENT}</label></div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="checkbox-wrapper">
                                    <div className="custom-checkbox"><input name="showDateRange" type="checkbox" id="check3" checked={userDocData.showDateRange} onChange={this.onHandleChange} /><label className="checkbox"htmlFor="check3"></label><label className="labeltext"htmlFor="check3">Show Date Range</label></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>}
                </ModalWindow>
            </div>
        )
        
    }
    
}
const mapStateToProps = (state) => {
    return {
        masterDocs : state.userDocs.masterDocItems, 
        masterDocStatus : state.userDocs.masterDocStatus, 
        masterDocActivity : state.userDocs.masterDocActivity, 
        userDocs : state.userDocs.items,
        userDoc:state.userDocs.item,
        status:state.userDocs.status,
        activity:state.userDocs.activity,
        count:state.userDocs.count,
        errorData:state.userDocs.errorData
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        userDocMasterListAction: userDocMasterListAction,
        userDocListAction:userDocListAction,  
        userDocAddAction:data=>userDocAddAction(data),
        userDocEditAction:id=>userDocEditAction(id),
        userDocUpdateAction:data=>userDocUpdateAction(data),
        userDocDeleteAction:id =>userDocDeleteAction(id),
        clearAction:clearAction           
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(ClientDocsComponent);